export * from './queryKeys';

// Customer status constants
export const CUSTOMER_STATUS_ACTIVE = 1;
export const CUSTOMER_STATUS_INACTIVE = 0;

// Account Status Enum (statuscode values from Dataverse - same as onboarding)
export enum AccountStatusEnum {
  ACCOUNT_CREATED = 1,
  SETUP_IN_PROGRESS = 736000001,
  SETUP_COMPLETE = 736000002,
}

// Account Status Options
export const ACCOUNT_STATUS_OPTIONS = [
  { label: "Account Created", value: AccountStatusEnum.ACCOUNT_CREATED },
  { label: "Setup In Progress", value: AccountStatusEnum.SETUP_IN_PROGRESS },
  { label: "Setup Complete", value: AccountStatusEnum.SETUP_COMPLETE },
];

// Modal content
export const CUSTOMERS_ACTIVE_MODAL_CONTENT = "Are you sure you want to activate this customer?";
export const CUSTOMERS_DEACTIVATE_MODAL_CONTENT = "Are you sure you want to deactivate this customer?";
export const CUSTOMERS_DELETE_MODAL_CONTENT = "Are you sure you want to delete this customer? This action cannot be undone.";

// Common constants
export const DEFAULT_PAGE_SIZE = 20;
export const DEFAULT_STARTING_PAGE = 1;
export const CANCEL_MODAL_CONFIRMATION_CONTENT = "You have unsaved changes. Are you sure you want to cancel?";

// Storage keys
export const CUSTOMER_STORAGE_KEY = "customers";
